module.exports = __webpack_public_path__ + "img/add.b69ed2b2.svg";